// Quick add for collections
// if (document.querySelectorAll('.quick-add--collections').length) {
//     document.querySelectorAll('.quick-add-select').forEach((select) => {
//         let selectId = select.getAttribute('id');
//         document.getElementById(selectId).addEventListener('change', (event) => {
//             event.stopImmediatePropagation();
//             this.quickAddItem(event.target.id);
//         });
//     });
// }

var productGridContainer = productGridContainer || document.getElementById('ProductGridContainer');

if (productGridContainer) {
    productGridContainer.addEventListener('change', (event) => {
        if (event.target.classList.contains('quick-add-select')) {
            event.stopImmediatePropagation();
            this.quickAddItem(event.target.id);
        }
    });
} else {
    // console.error("Product Grid Container not found");
}

// Quick add for product page
if (document.querySelectorAll('.quick-add-banner').length && document.getElementById('quickAddSubmit')) {
    document.getElementById('quickAddSubmit').addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        let productId = document.getElementById('quickAddSelect').id;
        this.quickAddItem(productId);
    });
}

function quickAddItem(quickSelectId) {
    let variantId = parseInt(document.getElementById(quickSelectId).value);

    fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
        }
    }).then(response => response.json()).then(cart => {

        let existingItem = cart.items.find(item => item.variant_id == variantId);

        if (existingItem) {

            let updatedQuantity = existingItem.quantity + 1;

            fetch('/cart/change.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                body: JSON.stringify({
                    id: existingItem.key,
                    quantity: updatedQuantity
                })
            }).then(response => response.json()).then(json => {
                this.openNotificationCart();
                this.getAllCartItems();
                document.querySelector('.cart__empty-text').style.display = 'none';
            }).catch(error => console.error(error));
        } else {

            let productData = {
                'id': variantId,
                'quantity': 1 /* should always be one for quick add */
            };

            let add_url = window.routes.cart_add_url;
            if (add_url.slice(-3) !== ".js") {
                add_url = add_url + ".js"; // Cart url should end in .js
            }

            fetch(add_url, {
                body: JSON.stringify(productData),
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                method: 'POST'
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                this.openNotificationCart();
                this.getAllCartItems();
                // hide empty cart message - shown again on interaction with cart items(e.g remove)
                document.querySelector('.cart__empty-text').style.display = 'none';
            }).catch(function (err) {
                console.error(err)
            });
        }
    }).catch(err => console.error(err));
}

function openNotificationCart() {
    document.querySelector('.cart-background').classList.add('active');
    document.getElementById('cart-notification').classList.add('animate', 'active');
    document.querySelector('.cart-notification-wrapper').classList.add('active');
    document.querySelector('body').classList.add('cart--open');

    document.getElementById('cart-notification').addEventListener('transitionend', () => {
        document.getElementById('cart-notification').focus();
        trapFocus(document.getElementById('cart-notification'));
    }, {
        once: true
    });
};

function getAllCartItems() {
    fetch(window.Shopify.routes.root + `cart.js?${document.querySelector('cart-notification').getSectionsToRender().map((section) => section.id)}`)
        .then(response => response.json())
        .then(data => {
            return document.querySelector('cart-notification').buildCart(data)
        });
}

// stick quick add banner on scroll when user scrolls past product details
function stickyScroll() {
    let banner = document.getElementById('quickAddBanner');
    let productForm = document.getElementById('main-product-form');
    let productMain = document.getElementById('product-main');
    if (banner !== null && productForm !== null && productMain !== null) {

        //let offset = banner.offsetTop;
        let offset = productForm.offsetTop + productForm.offsetHeight + productMain.offsetTop;

        function scrollTrigger(event) {
            let scrollMeasure = document['documentElement' || 'body'].scrollTop;
            if (scrollMeasure >= offset) {
                banner.classList.add('quick-add-banner--stick');
            } else {
                banner.classList.remove('quick-add-banner--stick');
            }

            // this accounts for the sticky header, which is present when scrolling upwards
            if (document.getElementById('shopify-section-header').classList.contains('shopify-section-header-hidden')) banner.classList.remove('quick-add-banner--sticky-header');
            else banner.classList.add('quick-add-banner--sticky-header');
        }

        window.addEventListener('scroll', scrollTrigger);

    }
}

if (document.readyState == 'complete' || document.readyState == 'loaded') {
    stickyScroll();
} else {
    window.addEventListener('DOMContentLoaded', stickyScroll);
}
